export const erc6492MagicBytes =
  '0x6492649264926492649264926492649264926492649264926492649264926492' as const

export const zeroHash =
  '0x0000000000000000000000000000000000000000000000000000000000000000' as const
